const ITEMS = [
  "Kanha", "Bandhavgarh", "Pench", "Satpura", "Panna", "Khajuraho",
  "Pachmarhi", "Orchha", "Bhedaghat", "Sanchi", "Ujjain", "Mandu",
];

export const Marquee = ({ reverse = false }) => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-gold/10 py-6 select-none"
    aria-hidden="true"
  >
    <div
      className="flex w-max animate-marquee"
      style={reverse ? { animationDirection: "reverse" } : undefined}
    >
      {[0, 1].map((n) => (
        <div key={n} className="flex items-center shrink-0">
          {ITEMS.map((item) => (
            <span key={`${n}-${item}`} className="flex items-center">
              <span className="font-serif text-2xl sm:text-3xl text-cream/25 px-8 whitespace-nowrap italic">
                {item}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-gold/40 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
